import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { clearSession, loadSession } from "./adminApi";
import ExpertAdminOverview from "./expert/ExpertAdminOverview";
import ExpertAdminRequests from "./expert/ExpertAdminRequests";
import ExpertAdminExperts from "./expert/ExpertAdminExperts";
import ExpertAdminResources from "./expert/ExpertAdminResources";
import ExpertAdminInjectedTasks from "./expert/ExpertAdminInjectedTasks";

const shell = { minHeight: "100vh", background: "#F3F6FB", fontFamily: "-apple-system,Segoe UI,Roboto,sans-serif" };
const topBar = {
  display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", rowGap: 8,
  background: "#0F1B2D", color: "white", position: "sticky", top: 0, zIndex: 10,
};
const container = { maxWidth: 1280, margin: "0 auto" };

const TABS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "requests", label: "Requests" },
  { id: "experts", label: "Experts" },
  { id: "resources", label: "Resources" },
  { id: "injected_tasks", label: "Injected Tasks" },
];

export default function ExpertAdmin() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("dashboard");

  useEffect(() => { if (!loadSession()) navigate("/admin", { replace: true }); }, [navigate]);

  const signOut = () => { clearSession(); navigate("/admin"); };

  return (
    <div data-testid="expert-admin-page" style={shell}>
      <div style={topBar} className="px-4 tablet:px-5 desktop:px-6 py-3">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button data-testid="expert-admin-back" onClick={() => navigate("/admin")}
            style={{ background: "transparent", color: "#94a3b8", border: "none", fontSize: 12, cursor: "pointer" }}>
            ← Admin
          </button>
          <span style={{ fontWeight: 700, fontSize: 16 }}>C-ORE Expert</span>
          <span style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1 }}>ops console</span>
        </div>
        <button data-testid="expert-admin-signout" onClick={signOut}
          style={{ background: "transparent", color: "#10b981", border: "1px solid #10b981", borderRadius: 6, padding: "4px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }}>
          <LogOut size={12} /> Sign Out
        </button>
      </div>

      <div style={container} className="px-4 tablet:px-5 desktop:px-6 py-4 desktop:py-6">
        <div data-testid="expert-admin-tabs" style={{ display: "flex", gap: 6, marginBottom: 18 }}>
          {TABS.map((t) => (
            <button key={t.id} data-testid={`expert-admin-tab-${t.id}`} onClick={() => setTab(t.id)}
              style={{
                background: tab === t.id ? "#1E3A5F" : "white", color: tab === t.id ? "white" : "#0F1B2D",
                border: "1px solid #E5E7EB", borderRadius: 8, padding: "7px 14px", fontSize: 12.5,
                fontWeight: 700, cursor: "pointer",
              }}>
              {t.label}
            </button>
          ))}
        </div>

        {tab === "dashboard" && <ExpertAdminOverview />}
        {tab === "requests" && <ExpertAdminRequests />}
        {tab === "experts" && <ExpertAdminExperts />}
        {tab === "resources" && <ExpertAdminResources />}
        {tab === "injected_tasks" && <ExpertAdminInjectedTasks />}
      </div>
    </div>
  );
}
